import { NgModule } from '@angular/core'
import { CommonModule, NgOptimizedImage } from '@angular/common'
import { RouterModule } from '@angular/router'
import { TranslateModule } from '@ngx-translate/core'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { AntdModule } from 'src/app/antd.module'
import { BreadcrumbsFilterComponent } from './components/breadcrumbs-filter/breadcrumbs-filter.component'
import { NgbdSortableHeader } from './directives/sortable-header.directive'
import { MsToSecPipe } from './pipes/ms-to-sec.pipe'
import { KeyValueFilterPipe } from './pipes/key-value-filter.pipe'
import { MainObjectDataCardTemplateComponent } from './pages/spas/common/main-object-data-card-template/main-object-data-card-template.component'
import { PaginationSizeComponent } from './components/pagination-size/pagination-size.component'
import { SelectionFilterPipe } from './pipes/selection-filter.pipe'
import { LabelMapPipe } from './pipes/label-map.pipe'
import { CalendarFilterComponent } from './components/calendar-filter/calendar-filter.component'
import { NiceDatePipe } from './pipes/nice-date.pipe'
import { FormatEventIdPipe } from './pipes/format-event-id.pipe'
import { TileNiceDatePipe } from './pipes/tile-nice-date.pipe'
import { DisableControlDirective } from './directives/disable-control.directive'
import { NumberWheelDirective } from './directives/number-wheel.directive'
import { OutsideClickDirective } from './directives/outside-click.directive'
import { NullAsWhateverPipe } from './pipes/null-as-dash.pipe'
import { ConfirmationModalComponent } from './pages/spas/common/confirmation-modal/confirmation-modal.component'
import { StoredFilterModalComponent } from './pages/spas/common/stored-filter-modal/stored-filter-modal.component'
import { HighchartsChartModule } from 'highcharts-angular'
import { DataValveComponent } from './pages/spas/common/main-object-data-card-template/data-valve/data-valve.component'
import { DataBreakerComponent } from './pages/spas/common/main-object-data-card-template/data-breaker/data-breaker.component'
import { DataFdComponent } from './pages/spas/common/main-object-data-card-template/data-fd/data-fd.component'
import { ComplexDatepickerComponent } from './components/complex-datepicker/complex-datepicker.component'
import { HistoryTrackingComponent } from './pages/spas/common/history-tracking/history-tracking.component'
import { SecureImagePipe } from './pipes/secure-image.pipe'
import { ConfigurationQueryBuilderComponent } from './components/configuration-query-builder/configuration-query-builder.component'
import { RuleComponent } from './components/configuration-query-builder/rule/rule.component'
import { GroupOfRulesComponent } from './components/configuration-query-builder/group-of-rules/group-of-rules.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { TextareaResizeDirective } from './directives/textarea-resize.directive'
import { BypassSecurityUrlPipe } from './pipes/bypass-security-url.pipe'
import { AnalysisFiltersModalComponent } from './pages/spas/common/analysis-components/analysis-filters-modal/analysis-filters-modal.component'
import { AnalysisViewDocumentItemsComponent } from './pages/spas/common/analysis-components/analysis-view-document-items/analysis-view-document-items.component'
import { AnalysisFilesContainerComponent } from './pages/spas/common/analysis-components/analysis-files-container/analysis-files-container.component'
import { AnalysisHistoryComponent } from './pages/spas/common/analysis-components/analysis-history/analysis-history.component'
import { FormDeviationUrlComponent } from './pages/spas/common/main-object-data-card-template/form-deviation-url/form-deviation-url.component'
import { FormMainComponent } from './pages/spas/common/main-object-data-card-template/form-main/form-main.component'
import { DataProcessTransmittersComponent } from './pages/spas/common/main-object-data-card-template/data-process-transmitters/data-process-transmitters.component'
import { DataBinaryProcessIniComponent } from './pages/spas/common/main-object-data-card-template/data-binary-process-ini/data-binary-process-ini.component'
import { DataFlameGasComponent } from './pages/spas/common/main-object-data-card-template/data-flame-gas/data-flame-gas.component'
import { DataSdlComponent } from './pages/spas/common/main-object-data-card-template/data-sdl/data-sdl.component'
import { DataBinaryFgIniComponent } from './pages/spas/common/main-object-data-card-template/data-binary-fg-ini/data-binary-fg-ini.component'
import { ChartLastYearOverviewComponent } from './pages/spas/common/main-object-data-card-template/data-flame-gas/chart-last-year-overview/chart-last-year-overview.component'
import { NewLineBreakerPipe } from './pipes/new-line-breaker.pipe'
import { FormatNumberSeparatorPipe } from './pipes/format-number-separator.pipe'
import { WindDirectionByDegreePipe } from './pipes/wind-direction-by-degree.pipe'
import { RcaTagComponent } from './pages/spas/common/main-object-data-card-template/rca-tag/rca-tag.component'
import { TtmSparklineChartComponent } from './pages/spas/common/sparkline-charts/ttm-sparkline-chart/ttm-sparkline-chart.component'
import { LsrSparklineChartComponent } from './pages/spas/common/sparkline-charts/lsr-sparkline-chart/lsr-sparkline-chart.component'
import { NotificationModalComponent } from './pages/spas/common/notification-components/notification-modal/notification-modal.component'
import { NotificationTooltipComponent } from './pages/spas/common/notification-components/notification-tooltip/notification-tooltip.component'
import { AnalysisUrlManagerComponent } from './pages/spas/common/analysis-components/analysis-url-manager/analysis-url-manager.component'
import { AddUrlModalComponent } from './pages/spas/common/analysis-components/analysis-url-manager/add-url-modal/add-url-modal.component'
import { DataWorkOrderComponent } from './pages/spas/common/notification-components/notification-modal/data-work-order/data-work-order.component'
import { DataNotificationComponent } from './pages/spas/common/notification-components/notification-modal/data-notification/data-notification.component'
import { IsCheckedComponent } from './components/is-checked/is-checked.component'
import { NotificationsModalComponent } from './pages/spas/common/main-object-data-card-template/notifications-modal/notifications-modal.component'
import { NotificationDataCardItemsComponent } from './pages/spas/common/notification-components/notification-data-card-items/notification-data-card-items.component'
import { CookiePolicyTextComponent } from './components/cookies-consent/cookie-policy-text/cookie-policy-text.component'
import { MultiSuggestionDropdownComponent } from './components/multi-suggestion-dropdown/multi-suggestion-dropdown.component'
import { NotifyUserComponent } from './components/notify-user/notify-user.component'
import { MaxTestRatingComponent } from './components/max-test-rating/max-test-rating.component'
import { TestRatingRangeSelectorComponent } from './components/test-rating-range-selector/test-rating-range-selector.component'
import { NzTooltipDirective } from "ng-zorro-antd/tooltip"

const MODULES: any[] = [
  CommonModule,
  RouterModule,
  AntdModule,
  TranslateModule,
  NgbModule,
  FormsModule,
  HighchartsChartModule,
  ReactiveFormsModule,
]

@NgModule({
  imports: [...MODULES, NgSelectModule, NgOptimizedImage, NzTooltipDirective],
  declarations: [
    BreadcrumbsFilterComponent,
    NgbdSortableHeader,
    DisableControlDirective,
    NumberWheelDirective,
    OutsideClickDirective,
    MsToSecPipe,
    KeyValueFilterPipe,
    SelectionFilterPipe,
    LabelMapPipe,
    MainObjectDataCardTemplateComponent,
    FormMainComponent,
    FormDeviationUrlComponent,
    DataProcessTransmittersComponent,
    DataBinaryProcessIniComponent,
    DataFlameGasComponent,
    ChartLastYearOverviewComponent,
    PaginationSizeComponent,
    CalendarFilterComponent,
    NiceDatePipe,
    FormatEventIdPipe,
    TileNiceDatePipe,
    NullAsWhateverPipe,
    FormatNumberSeparatorPipe,
    WindDirectionByDegreePipe,
    ConfirmationModalComponent,
    StoredFilterModalComponent,
    DataValveComponent,
    DataBreakerComponent,
    DataFdComponent,
    DataSdlComponent,
    DataBinaryFgIniComponent,
    ComplexDatepickerComponent,
    HistoryTrackingComponent,
    SecureImagePipe,
    ConfigurationQueryBuilderComponent,
    RuleComponent,
    GroupOfRulesComponent,
    TextareaResizeDirective,
    BypassSecurityUrlPipe,
    AnalysisFiltersModalComponent,
    AnalysisViewDocumentItemsComponent,
    AnalysisFilesContainerComponent,
    AnalysisHistoryComponent,
    NewLineBreakerPipe,
    RcaTagComponent,
    TtmSparklineChartComponent,
    LsrSparklineChartComponent,
    NotificationModalComponent,
    NotificationTooltipComponent,
    AnalysisUrlManagerComponent,
    AddUrlModalComponent,
    DataWorkOrderComponent,
    DataNotificationComponent,
    IsCheckedComponent,
    NotificationsModalComponent,
    NotificationDataCardItemsComponent,
    CookiePolicyTextComponent,
    MultiSuggestionDropdownComponent,
    NotifyUserComponent,
    MaxTestRatingComponent,
    TestRatingRangeSelectorComponent,
  ],
  exports: [
    ...MODULES,
    BreadcrumbsFilterComponent,
    NgbdSortableHeader,
    DisableControlDirective,
    OutsideClickDirective,
    MsToSecPipe,
    KeyValueFilterPipe,
    SelectionFilterPipe,
    LabelMapPipe,
    MainObjectDataCardTemplateComponent,
    FormMainComponent,
    FormDeviationUrlComponent,
    DataProcessTransmittersComponent,
    DataBinaryProcessIniComponent,
    DataFlameGasComponent,
    ChartLastYearOverviewComponent,
    PaginationSizeComponent,
    CalendarFilterComponent,
    NiceDatePipe,
    FormatEventIdPipe,
    TileNiceDatePipe,
    NullAsWhateverPipe,
    FormatNumberSeparatorPipe,
    WindDirectionByDegreePipe,
    DataValveComponent,
    DataBreakerComponent,
    DataFdComponent,
    DataSdlComponent,
    DataBinaryFgIniComponent,
    ComplexDatepickerComponent,
    HistoryTrackingComponent,
    SecureImagePipe,
    ConfigurationQueryBuilderComponent,
    TextareaResizeDirective,
    BypassSecurityUrlPipe,
    AnalysisFiltersModalComponent,
    AnalysisViewDocumentItemsComponent,
    AnalysisFilesContainerComponent,
    AnalysisHistoryComponent,
    NewLineBreakerPipe,
    RcaTagComponent,
    TtmSparklineChartComponent,
    LsrSparklineChartComponent,
    NotificationTooltipComponent,
    NotificationModalComponent,
    AnalysisUrlManagerComponent,
    IsCheckedComponent,
    DataNotificationComponent,
    NotificationDataCardItemsComponent,
    CookiePolicyTextComponent,
    MultiSuggestionDropdownComponent,
    NotifyUserComponent,
    MaxTestRatingComponent,
    TestRatingRangeSelectorComponent,
  ],
})
export class SharedModule {}
